import React from 'react'
import PropTypes from 'prop-types'

import { withStyleSheetOverride } from '@klarna/higher-order-components'

import {
  constants,
  IconAppLauncher,
  IconAssets,
  IconDebt,
  IconDelivery,
  IconFinancial,
  IconKlarnaK,
  IconOrder,
  IconOther,
  IconProfile,
  IconSettings,
  IconSpeechBubble,
  IconStores,
  IconTransfers,
  IconTruck,
  TitlePrimary,
  IconRocket,
  IconCreditCard,
  IconAssistant
} from 'mage-deps/@klarna/bubble-ui'
import { constants as commonConstants } from 'mage-common'
import * as R from 'ramda'

const GRID_SIZE = constants.Grid.SIZE
const { CLIENT_IDS } = commonConstants

function getDefaultStyleSheet ({ hover }) {
  const size = 5 * GRID_SIZE
  return {
    container: {
      width: size,
      minWidth: size,
      height: size,
      background: constants.Colors.TRANSPARENT,
      cursor: hover ? 'pointer' : 'default',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative'
    }
  }
}

function renderIcon (clientId, color) {
  switch (clientId) {
    case CLIENT_IDS.NKO_APP:
      return <IconKlarnaK color={color} />
    case CLIENT_IDS.ORDERS:
    case CLIENT_IDS.NKO_ORDERS:
      return <IconOrder color={color} />
    case CLIENT_IDS.SETTLEMENTS:
    case CLIENT_IDS.NKO_SETTLEMENTS:
      return <IconAssets color={color} />
    case CLIENT_IDS.LOGS:
      return <IconTransfers color={color} />
    case CLIENT_IDS.USERS:
      return <IconProfile color={color} />
    case CLIENT_IDS.SETTINGS:
    case CLIENT_IDS.NKO_SETTINGS:
      return <IconSettings color={color} />
    case CLIENT_IDS.SELLER:
      return <IconStores color={color} />
    case CLIENT_IDS.UPSTREAM:
      return <IconSpeechBubble color={color} />
    case CLIENT_IDS.HOME:
      return <IconAppLauncher color={color} />
    case CLIENT_IDS.LENDING:
      return <IconTruck color={color} />
    case CLIENT_IDS.BRANDING:
      return <IconOther color={color} />
    case CLIENT_IDS.PRODUCTS:
      return <IconKlarnaK color={color} />
    case CLIENT_IDS.INSIGHTS:
      return <IconFinancial color={color} />
    case CLIENT_IDS.DISPUTES:
      return <IconDebt color={color} />
    case CLIENT_IDS.LOGISTICS:
      return <IconDelivery color={color} />
    case CLIENT_IDS.MARKETING:
      return <IconRocket color={color} />
    case CLIENT_IDS.BUSINESS_CARD:
      return <IconCreditCard color={color} />
    case CLIENT_IDS.SUPPORT:
      return <IconAssistant color={color} />
    default:
      return clientId
        ? (
          <div style={{ position: 'relative', top: -3, opacity: 0.7 }}>
            <TitlePrimary white centered>{clientId.substr(0, 1).toLocaleLowerCase()}</TitlePrimary>
          </div>
        )
        : null
  }
}

export function AppIcon ({ styleSheet, clientId, color }) {
  return (
    <div style={styleSheet.container}>
      {renderIcon(clientId, color)}
    </div>
  )
}

AppIcon.defaultProps = {
  color: 'black'
}

AppIcon.propTypes = {
  styleSheet: PropTypes.object.isRequired,
  clientId: PropTypes.oneOf(Object.values(CLIENT_IDS)).isRequired,
  color: PropTypes.string
}

export default R.compose(
  withStyleSheetOverride(getDefaultStyleSheet)
)(AppIcon)
